export const INSTANT_BOOK_INTEGER_ID = '89';
export const INSTANT_BOOK_FILTER_ID = `filter:${INSTANT_BOOK_INTEGER_ID}`;
export const LEGACY_INSTANT_BOOK_ID = 'booking_title:instant_booking';
// non US brands localize "booking options" but not "instant book", e.g. for Fewo it's "Buchungsoptionen:Instant+book"
// so we can just check to see if the link value contains "instant book"
export const INSTANT_BOOK_SLOT_VALUE = 'instant book';
export const PETS_INCLUDED_FILTER_ID = 'filter:27';
